import "./search.css"
import PrivateApi from "../../../services/PrivateApiService";
import { FaArrowDown, FaArrowUp, FaChevronLeft, FaSearch, FaTimes } from "react-icons/fa";
import { Badge, Spinner } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { BsBuildingsFill, BsFillFileEarmarkTextFill } from "react-icons/bs";
import SearchBadge from "./SearchBadge";
import SearchResults from "./results/SearchResults";

const HwSearchModal = ({ show, setShow }) => {
    const API = new PrivateApi();
    
    const searchCategories = [
        {name: "Gebäude", icon: <BsBuildingsFill />},
        {name: "Dokumente", icon: <BsFillFileEarmarkTextFill />},
        {name: "Energielieferverträge", icon: <BsBuildingsFill />}
    ];
    const [activeCategories, setActiveCategories] = useState(searchCategories.map(category => category.name));
    const [searchTerm, setSearchTerm] = useState("");
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const inputRef = useRef(null);
    const [showMoreUsed, setShowMoreUsed] = useState(true);

    
    useEffect(() => {
        if (!show) return; 
        inputRef.current?.focus();
        setShowMoreUsed(false)
    }, [show])

    const categoryToggle = (cat) => {
        setActiveCategories(prev =>
            prev.includes(cat)
                ? prev.filter(c => c !== cat)
                : [...prev, cat]
        );
    }


    const search = (category=null, page=0) => {
        // don't allow term smaller than 3 chars
        if (searchTerm.length < 3) return;
        // don't allow same term search
        if (data?.term === searchTerm && category === null) return;

        setActiveCategories(searchCategories.map(category => category.name));
        
        let payload = {
            term: searchTerm,
            categories: searchCategories.map(category => category.name),
        };
        
        setShowMoreUsed(false);

        if (category) {
            if (!data) return;
            setShowMoreUsed(true);
            setActiveCategories([category]);
            setSearchTerm(data.term);
            payload.categories = [category];
            payload.show_more = true;
        }

        if (page > 0) {
            payload.page = page;
        }

        setData(null);
        setIsLoading(true);

        // api call
        API.hw_search(payload)
            .then(res => {
                setData(res.data);
            })
            .finally(() => setIsLoading(false))
    }

    const backHandler = () => {
        if (!data.term) return;

        setShowMoreUsed(false);
        setActiveCategories(searchCategories.map(category => category.name));

        let payload = {
            term: data.term,
            categories: searchCategories.map(category => category.name),
            page: 0

        };

        setData(null);
        setIsLoading(true);

        // api call
        API.hw_search(payload)
            .then(res => {
                setData(res.data);
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <div className="search-modal" onMouseDown={(e) => {
            if (e.target === e.currentTarget) {
                setShow(false)
            }
        }}>
            <div className="input-header">
                <div className="search-input">
                    <FaSearch />
                    <input 
                        ref={inputRef}
                        type="text"
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        onKeyDown={e => { if(e.key === "Enter") {search();} }}
                        disabled={isLoading}
                    />
                    {searchTerm &&
                        <button 
                            className="clear-btn"
                            onClick={() => setSearchTerm("")}
                            type="button"
                        >
                            <FaTimes />
                        </button>
                    }
                </div>
                <div className="mx-3 mb-2 d-flex justify-content-between">
                    <div className="d-flex gap-1">
                        Navigieren
                        <Badge bg="dark" text="light"><FaArrowUp /></Badge>
                        <Badge bg="dark" text="light"><FaArrowDown /></Badge>
                    </div>
                    <div className="d-flex gap-1" onClick={() => setShow(false)} style={{cursor: "pointer"}}>
                        Schließen
                        <Badge bg="dark" text="light">esc</Badge>
                    </div>
                </div>
            </div>
            <div className="search-modal-body" hidden={!data && !isLoading}>
                <div className="header-section">
                    {showMoreUsed === false?
                        <div className="d-flex gap-1">
                            {searchCategories.map(cat => (
                                <SearchBadge 
                                key={cat.name}
                                icon={cat.icon} 
                                text={cat.name} 
                                isActive={activeCategories?.includes(cat.name)}
                                clickHandler={categoryToggle}
                                />
                            ))}
                        </div>
                        :
                        <a 
                            hidden={isLoading}
                            href="/resultate/alle" 
                            className="link-energo"
                            onClick={e => {e.preventDefault(); backHandler(); }}
                        >
                            <FaChevronLeft /> Zurück
                        </a>
                    }
                    <hr hidden={isLoading} />
                </div>
                <div hidden={!isLoading} className="text-center text-energo mt-3"><Spinner animation="border" /></div>
                <div hidden={data === null || (data?.buildings_count === 0 && data?.docs_count === 0 && data.elvs_count === 0)}>
                    <SearchResults data={data} activeCategories={activeCategories} setShow={setShow} searchHandler={search} />
                </div>
                {data && searchTerm === data.term &&
                    data.result.buildings.items.length === 0 &&
                    data.result.documents.items.length === 0 &&
                    data.result.elvs.items.length === 0 &&

                    <p className="text-muted text-center">Keine Ergebnisse zur Suche nach <span className="text-dark">{searchTerm}</span></p>
                }
            </div>
        </div>
    )
}
export default HwSearchModal;